// extracted by mini-css-extract-plugin
export default {"ButtonStyle":"SinglePageable_ButtonStyle__GT1hK"};